import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../common/components/Button";
import { toast } from "../../common/components/Toast";
import { SPACING } from "../../common/constants/spacing";
import { useCreateSupportTicket } from "../api/support";

function CreateTicketDialog({ open, onClose, onTicketCreated }) {
  const { t } = useTranslation("support");
  const [newTicket, setNewTicket] = useState({
    subject: "",
    priority: "medium",
    content: "",
  });
  const { createTicket } = useCreateSupportTicket();

  const handleCreateTicket = async () => {
    try {
      if (!newTicket.subject.trim() || !newTicket.content.trim()) {
        toast.error(t("createDialog.errors.requiredFields"));
        return;
      }

      await createTicket(newTicket);
      toast.success(t("createDialog.success"));
      setNewTicket({
        subject: "",
        priority: "medium",
        content: "",
      });
      onTicketCreated();
    } catch (error) {
      toast.error(t("createDialog.errors.failed"));
      console.error("Error creating ticket:", error);
    }
  };

  const handleClose = () => {
    setNewTicket({
      subject: "",
      priority: "medium",
      content: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("createDialog.title")}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            name="subject"
            label={t("createDialog.fields.subject")}
            value={newTicket.subject}
            onChange={(e) =>
              setNewTicket({ ...newTicket, subject: e.target.value })
            }
            sx={{ mb: SPACING.sm }}
            required
          />
          <TextField
            select
            fullWidth
            name="priority"
            label={t("createDialog.fields.priority")}
            value={newTicket.priority}
            onChange={(e) =>
              setNewTicket({ ...newTicket, priority: e.target.value })
            }
            sx={{ mb: SPACING.sm }}
          >
            <MenuItem value="low">{t("priorities.low")}</MenuItem>
            <MenuItem value="medium">{t("priorities.medium")}</MenuItem>
            <MenuItem value="high">{t("priorities.high")}</MenuItem>
            <MenuItem value="urgent">{t("priorities.urgent")}</MenuItem>
          </TextField>
          <TextField
            fullWidth
            name="content"
            label={t("createDialog.fields.message")}
            multiline
            rows={4}
            value={newTicket.content}
            onChange={(e) =>
              setNewTicket({ ...newTicket, content: e.target.value })
            }
            placeholder={t("createDialog.fields.messagePlaceholder")}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={handleClose}>
          {t("createDialog.actions.cancel")}
        </Button>
        <Button
          onClick={handleCreateTicket}
          variant="contained"
          disabled={!newTicket.subject.trim() || !newTicket.content.trim()}
        >
          {t("createDialog.actions.create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateTicketDialog;
